import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jpp7njnwcc: FaireBrandEntity = {
  token: "b_jpp7njnwcc",
  type: "brand",
  name: "Tablespoon Cooking Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/fe2046265f3ca9ff7852970b8cd6b545c577e2ba723165f93f57024408272acc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a9c8d2ab52865403c9221ed4c3ac359aefbb1f1ad5e0646d32c6a51cc8a578f4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fe2046265f3ca9ff7852970b8cd6b545c577e2ba723165f93f57024408272acc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9c8d2ab52865403c9221ed4c3ac359aefbb1f1ad5e0646d32c6a51cc8a578f4.jpeg",
  location: "Cincinnati, OH, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "We are culinary confidence builders on a mission to demystify the kitchen through cooking classes and events that are anything but boring. Our team of professional chefs and educators strive to help cooks of all skill levels learn, practice, and master the skills and recipes that help make cooking a joyful experience. Not only do we bring years of experience into the classroom, but our playlist is on-point, our bar is well-stocked, and we guarantee that you won’t leave hungry. Our goal at Tablespoon is teach cooks of all skill levels how to #cookgoodfood and reach their true potential in the kitchen.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:10.873Z",
    importedBy: "entity-db-cli",
  },
};
